import { FC, useEffect, useState } from "react"
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog"
import { Button } from "../ui/button"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import { useTranslation } from "@/hooks/use-translation"

interface NewTemplateDialogProps {
  open: boolean
  initialName?: string
  onCancel: () => void
  onConfirm: (name: string) => void
}

export const NewTemplateDialog: FC<NewTemplateDialogProps> = ({
  open,
  initialName = "",
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation()
  const [name, setName] = useState(initialName)

  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  const canSave = name?.trim().length > 0

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel() }}>
      <DialogContent className="max-w-md">
        <DialogTitle>{t("dashboard.dialogs.title.saveAsNewTemplate")}</DialogTitle>
        <div className="flex flex-col space-y-6 py-2">
          <div>
            <Label htmlFor="new-template-name">{t("dashboard.dialogs.templateName")}</Label>
            <Input
              id="new-template-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("dashboard.dialogs.templateNamePlaceholder")}
              className="mt-1"
            />
          </div>
          <div className="w-full flex items-center justify-between gap-4">
            <Button variant="outline" className="flex-1" onClick={onCancel}>{t("common.cancel")}</Button>
            <Button
              className="flex-1 bg-slate-800 hover:bg-slate-700"
              onClick={() => onConfirm(name?.trim())}
              disabled={!canSave}
            >
              {t("common.save")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

